import React, { useEffect, useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
import { withRouter } from 'react-router-dom';
import axios from "@fuse/utils/axios";
import { setrowGroupModel } from 'app/main/service-request/store/filterParamsReducer';
// import { setSerialNumberForServiceRequest } from 'app/main/service-request/store/filterParamsReducer';
import { setServiceTicketsCount } from 'app/main/assets/store/formViewDialogReducer'
import { useDispatch } from 'react-redux';
import { useRouter } from '@fuse/hooks';
import useToast from '@fuse/hooks/useToast'
import { AgGridReact } from 'ag-grid-react';
import '../../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';

const useStyles = makeStyles(theme => ({
	loader: {
		display: 'flex',
		marginTop: '27px',
		marginLeft: '10px',
		'& > * + *': {
			marginLeft: theme.spacing(2),
		},
	},
	drawerWidth: {
		width: 600
	},
	uploadImageButton: {
		padding: '10px 36px',
		fontSize: '1.3rem',
		minWidth: '64px',
		boxSizing: 'border-box',
		transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		fontFamily: 'Inter, sans-serif',
		fontWeight: 500,
		lineHeight: 1.75,
		borderRadius: '4px',
		textTransform: 'none',
		backgroundColor: '#6B2C57',
		color: '#ffffff',
		cursor: 'pointer',
		marginTop: "25px"
	},
	subSection: {
		marginLeft: '20px !important',
		marginRight: '20px !important',
		marginBottom: '20px !important',
		padding: '10px',
		backgroundColor: '#f4f4f4',
		borderRadius: '4px'
	},
	endButtons: {
		borderRadius: '4px'
	},
}))


function ServiceRequestsTab(props) {
	const table_name = "SERVICE_REQUEST";

	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);

	const gridRef = useRef()

	const onGridReady = params => {
		// Following line to make the currently visible columns fit the screen  
		params.api.sizeColumnsToFit();

		// Following line dymanic set height to row on content
		params.api.resetRowHeights();
	};

	const tableHeaders = [
		"ticket_number", "serial_number", "title", "priority", "status", "agent_name", "created_date", "updated_date"
	];

	const classes = useStyles();
	const router = useRouter()
	const [serviceRequests, setServiceRequests] = useState([])
	const [loading, setLoading] = useState(false)
	const { assetDetails } = props

	const dispatch = useDispatch();
	const toast = useToast(dispatch);

	function formatServiceRequests(serviceRequests) {
		return serviceRequests.map((item) => {
			return {
				id: item.id,
				ticket_number: item.ticket_id,
				serial_number: item.asset.serial_number,
				title: item.title,
				priority: item.service_request_priority ? item.service_request_priority?.name : 'N/A',
				status: item.service_request_status ? item.service_request_status?.status_name : 'N/A',
				status_details: {
					id: item?.service_request_status?.id,
					status_name: item?.service_request_status?.status_name,
					status_color: item?.service_request_status?.status_color
				},
				agent_name: item.agent ? `${item.agent.first_name} ${item.agent.last_name}` : 'N/A',
				service_request_status: item.service_request_status ?? 'N/A',
				deleted_at: item.deleted_at,
				created_date: item.created_at ? getLocalTimeFromUTC(item.created_at) : '-',
				updated_date: item.updated_at ? getLocalTimeFromUTC(item.updated_at) : '-',
			}
		})
	}
	function getServiceRequests() {
		if (!assetDetails) return
		// setLoading(true)
		axios.get(`/assets/fetch-asset-service-request/${assetDetails.id}?archived=${true}`, {
		}).then((res) => {
			const { response } = res.data.data;
			setServiceRequests(formatServiceRequests(response))
			dispatch(setServiceTicketsCount(response.length))
		}).catch((err) => {
			console.log(err)
		}).finally(() => {
			// setLoading(false)
		})
	}

	useEffect(() => {
		getServiceRequests()
	}, [])

	if (loading) {
		return (
			<FuseLoading />
		)
	}

	const generateHeaderLabel = (header) => {
		if (header == 'accessory_category_id') {
			return 'Accessory Category Name'
		} if (header == 'manufacturer_id') {
			return 'Manufacturer Name'
		} if (header === 'detailed_description_of_the_issue') {
			return 'Issue Description'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	function handleHideColumnDropDownDesign() {
		return  {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      border: "1px solid #000000",
      borderRadius: "20px",
      padding: "3px 10px",
      backgroundColor: "#ffffff",
      lineHeight: "1",
      height: "28px",
      position: "relative",
      cursor: "pointer",
      fontFamily: '"Inter", sans-serif',
      fontSize: "13px",
      fontWeight: 500,
    };
	}


	function onSortChanged(params) {
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function saveView(rows, filter) {
		let payload = {}
		if (rows == 'N/A') {
			payload = {
				filter: JSON.stringify(filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	function redirectToServiceTicketProfile(event) {
		if (event?.data?.deleted_at) {
			router.push(`/archive-service-tickets/${event?.data.id}`)
		} else {
			router.push(`/service-tickets/${event?.data.id}`)
		}
	}


	return (
		<div className={classes.root}>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme='legacy'
					rowData={serviceRequests}
					animateRows
					rowHeight={28}
          headerHeight={44}
					onGridReady={onGridReady}
					paginationPageSize={10}
					paginationPageSizeSelector={[10, 20, 50, 100]}
					pagination
					onSortChanged={onSortChanged}
					defaultColDef={{
						resizable: true,
						sortable: true,
						filter: "agTextColumnFilter",
						flex: 1,
					}}
					columnDefs={tableHeaders.map((header) => {
						if (header === "ticket_number") {
						return {
							field: header,
							headerName: generateHeaderLabel(header),
							minWidth: 200,
							cellRenderer: (params) => {
							return (
								<a
								style={{
									color: "black",
									cursor: "pointer",
									fontWeight: 500,
									textDecoration: "none",
								}}
								onClick={() => redirectToServiceTicketProfile(params)}
								>
								{params.value}
								{params.data?.deleted_at ? " (Archived)" : ""}
								</a>
							);
							},
							headerComponent: (props) => CustomFilter(props, header, gridRef),
						};
						}

						if (header === "status") {
						return {
							field: header,
							headerName: generateHeaderLabel(header),
							minWidth: 230,
							editable: false,
							cellRenderer: (params) => {
							const [status, color] = params.value?.split(",") || [];
							return (
								<span style={handleHideColumnDropDownDesign()}>
								<span
									style={{
									height: "10px",
									width: "10px",
									marginTop: "2px",
									borderRadius: "50%",
									display: "inline-block",
									backgroundColor:
										color ?? params.data?.status_details?.status_color?.code,
									}}
								/>
								<span
									style={{
									marginLeft: "5px",
									fontSize: "12px",
									fontWeight: "500",
									color: "black",
									fontFamily: '"Inter", sans-serif',
									}}
								>
									{status}
								</span>
								</span>
							);
							},
							headerComponent: (props) => CustomFilter(props, header, gridRef),
						};
						}

						return {
						field: header,
						headerName: generateHeaderLabel(header),
						minWidth:
							header === "created_date" || header === "updated_date" ? 300 : 170,
						wrapText: true,
						headerComponent: (props) => CustomFilter(props, header, gridRef),
						};
					})}
				 />
			</div>
		</div>
	)
}

export default withRouter(ServiceRequestsTab)
